


















import Vue from 'vue'

type Data = {
  isOpen: boolean;
};

export default Vue.extend({
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data (): Data {
    return {
      isOpen: false
    }
  },
  methods: {
    toggle (): void {
      this.isOpen = !this.isOpen
    }
  }
})
